$ = require 'jquery'

module.exports =
class Elements

  @selectors:
    window  : window
    document: document
    body    : 'body'

  ###
  create Elements instance
  ###
  constructor: ->
    _.forEach Elements.selectors, (selector, name) ->
      selectorName = "$#{name}"
      Elements[selectorName] = $ selector



/** WEBPACK FOOTER **
 ** ./webpack/requires/pc/elements.coffee
 **/